import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApiServices } from '../../services/api-endpoints/useApiServices';
import ChatWidget from '../chat/ChatWidget';
import { useSignalR } from '../../services/signalR/SignalRProvider';

const getInitials = (name = '') => {
    const parts = name.trim().split(' ');
    return parts.length >= 2
        ? (parts[0][0] + parts[1][0]).toUpperCase()
        : name.slice(0, 2).toUpperCase();
};

const getAvatarColor = (name = '') => {
    const colors = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444', '#06b6d4', '#f97316'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
};

const RightSidebar = ({ show }) => {
    const { messages } = useSignalR();
    const { GetChatHeadsAsync } = useApiServices();

    const [selectedUser, setSelectedUser] = useState(null);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [chatHeads, setChatHeads] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchHeads = async () => {
        setIsLoading(true);
        try {
            const data = await GetChatHeadsAsync({ page: 1, pageSize: 50 });
            if (Array.isArray(data)) setChatHeads(data);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (show) fetchHeads();
    }, [show]);

    useEffect(() => {
        if (!messages?.length) return;
        const lastEntry = messages[messages.length - 1];
        const last = typeof lastEntry === 'string' ? JSON.parse(lastEntry) : lastEntry;
        if (last?.Type === 'Message' && show) fetchHeads();
    }, [messages]);

    const openChat = (userId) => {
        setSelectedUser(userId);
        setIsChatOpen(true);
    };

    const toggleChat = () => setIsChatOpen((prev) => !prev);

    return (
        <>
            <nav className={show ? 'toggle-sidebar right-sidebar-toggle' : 'toggle-sidebar'} style={{ zIndex: 999 }}>
                <div className="nano">
                    <div className="nano-content">
                        <div style={{ padding: '12px 0' }}>
                            {/* Header */}
                            <div style={{ padding: '0 14px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f3f4f6' }}>
                                <span style={{ fontWeight: 700, fontSize: 14, color: '#1f2937' }}>แชท</span>
                                <Link
                                    to="/app-chat"
                                    style={{ fontSize: 11, color: '#6b7280', textDecoration: 'none' }}
                                >
                                    ดูทั้งหมด →
                                </Link>
                            </div>

                            {/* List */}
                            {isLoading ? (
                                <div style={{ padding: '24px 0', textAlign: 'center' }}>
                                    <i className="fa fa-spinner fa-spin" style={{ color: '#9ca3af', fontSize: 18 }} />
                                </div>
                            ) : chatHeads.length === 0 ? (
                                <div style={{ padding: '24px 14px', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
                                    ยังไม่มีการสนทนา
                                </div>
                            ) : (
                                <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                                    {chatHeads.map((head) => {
                                        const name = head.displayName || '';
                                        const color = getAvatarColor(name);
                                        const initials = getInitials(name);
                                        return (
                                            <li key={head.userId}>
                                                <button
                                                    onClick={() => openChat(head.userId)}
                                                    style={{
                                                        width: '100%', display: 'flex', alignItems: 'center',
                                                        gap: 10, padding: '9px 14px', background: 'none',
                                                        border: 'none', cursor: 'pointer', textAlign: 'left',
                                                        transition: 'background 0.15s',
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                                    onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
                                                >
                                                    <div style={{
                                                        width: 38, height: 38, borderRadius: '50%',
                                                        background: color, color: '#fff',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        fontWeight: 700, fontSize: 13, flexShrink: 0,
                                                    }}>
                                                        {head.pictureUrl
                                                            ? <img src={head.pictureUrl} alt={name} style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover' }} />
                                                            : initials
                                                        }
                                                    </div>
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontWeight: 600, fontSize: 13, color: '#1f2937', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {name}
                                                        </div>
                                                        <div style={{ fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 1 }}>
                                                            {head.lastMessage || '...'}
                                                        </div>
                                                    </div>
                                                    {head.unreadCount > 0 && (
                                                        <div style={{
                                                            minWidth: 18, height: 18, borderRadius: 9,
                                                            background: '#ef4444', color: '#fff',
                                                            fontSize: 10, fontWeight: 700,
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            padding: '0 4px', flexShrink: 0,
                                                        }}>
                                                            {head.unreadCount}
                                                        </div>
                                                    )}
                                                </button>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
            <ChatWidget
                isOpen={isChatOpen}
                onToggle={toggleChat}
                selectedUserId={selectedUser}
            />
        </>
    );
};

export default RightSidebar;
